import type { LucideIcon } from "lucide-react"

interface ComingNextFeatureCardProps {
  title: string
  description: string
  icon: LucideIcon
  items: string[]
  footerItems?: string[]
}

export function ComingNextFeatureCard({
  title,
  description,
  icon: Icon,
  items,
  footerItems,
}: ComingNextFeatureCardProps) {
  return (
    <article className="w-full min-w-full shrink-0 snap-start rounded-xl border border-[var(--color-ask-dynamo)]/25 bg-[var(--color-ask-dynamo-dashboard-bg)] p-4 shadow-[0_4px_20px_rgba(108,61,242,0.08)]">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--color-ask-dynamo)] text-white">
          <Icon size={18} aria-hidden />
        </span>
        <div className="min-w-0">
          <h2 className="text-lg font-semibold text-[var(--color-ask-dynamo-muted)]">{title}</h2>
          <p className="mt-1 text-sm font-medium text-[var(--color-text-primary)]">{description}</p>
        </div>
      </div>
      <ul className="mt-3 space-y-1 text-sm text-[var(--color-ask-dynamo-muted)]">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--color-ask-dynamo)]" aria-hidden />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      {footerItems && footerItems.length > 0 && (
        <div className="mt-4 grid grid-cols-3 gap-2 border-t border-[var(--color-ask-dynamo)]/15 pt-3">
          {footerItems.map((label) => (
            <p
              key={label}
              className="text-center text-[10px] leading-tight font-medium text-[var(--color-ask-dynamo-muted)]"
            >
              {label}
            </p>
          ))}
        </div>
      )}
    </article>
  )
}
